import React from 'react';


const NavigationBar = ({items, selected, onChange}) => {
    
    return (
        <div className='navigation-bar'>
            {items.map(({value, id}, i) => (
                <div key={i} 
                     className={'navigation-bar-item ' + (id === selected ? 'active' : '')}
                     onClick={() => onChange(id)}
                     >{value}</div>
            ))}    
        </div>
    );
}


export default NavigationBar;